var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleAuthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7272_26782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0615 18.7744C20.1709 16.8057 21.1084 13.5244 20.5459 10.3838H12.1553V13.8525H16.9365C16.749 14.9775 16.0928 15.915 15.1553 16.5244L18.0615 18.7744Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 15.9844C4.83539 17.1991 5.71974 18.258 6.80512 19.0812C7.89051 19.9044 9.14861 20.4705 10.4846 20.7368C11.8206 21.0031 13.1996 20.9627 14.5177 20.6185C15.8357 20.2743 17.0585 19.6354 18.0938 18.75L15.1875 16.5C12.7031 18.1406 8.57812 17.5312 7.17188 13.6875L4.21875 15.9844Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.172 13.6875C6.797 12.5156 6.797 11.4375 7.172 10.2656L4.21887 7.96875C3.14075 10.125 2.81262 13.1719 4.21887 15.9844L7.172 13.6875Z",
    fill: "#FBBC02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17188 10.2654C8.20312 7.03103 12.6094 5.15603 15.5625 7.92166L18.1406 5.39041C14.4844 1.87478 7.35938 2.01541 4.21875 7.96853L7.17188 10.2654Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7272_26782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuthIcon);
export default __webpack_public_path__ + "static/media/google-auth-icon.5ce9b7e10d417e3aa82c1023869c099e.svg";
export { ForwardRef as ReactComponent };